export const figure13e = {
    chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
      },
      credits: {
        enabled: false
    },
      title: {
        text: 'Canada'
      },
      subtitle: {
        text: null
    },
      xAxis: {
        categories: ['2001','2006','2011', '2016',]
      },
      labels: {
        	
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      yAxis: {
        min: 0,
        max: 2000,
        tickInterval: 500,
        title: {
            text: null,
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
    },
    legend: {
        enabled: false,
    },
      colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
      series: [{
        name: 'Petites exploitations',
        data: [39.3, 38.7, 76.2, 83.5,]
      },{
        name: 'Autres exploitations',
        data: [668.0, 872.4, 1173.9, 1688.4,]
      },{
        name: 'Petites exploitations dirigées par une femme',
        data: [29.9, 31.3, 60.9, 68.7,]
      },{
        name: 'Petites exploitations dirigées par un homme',
        data: [42.7, 41.6, 83.1, 90.8,]
      }, 
    ]
    }

    